/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
IncidenciaService.$inject = ['$resource'];
export default function IncidenciaService($resource) {
    var urlBase = Sigo.var.path + '/api/v1' + '/incidencias' + '/:incidenciaId';

    return $resource(urlBase, {
            incidenciaId: '@incidenciaId'
        }, {
            'edit': {method: 'GET', url: urlBase + '/edit'},
            'update': {method: 'PUT'}
        }
    );
}